import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";
import SiteMeta from "./components/SiteMeta";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VenueForgotPassword from "./pages/VenueForgotPassword";
import VenueResetPassword from "./pages/VenueResetPassword";
import Dashboard from "./pages/dashboard/Dashboard";
import StaffDoor from "./pages/StaffDoor";
import AdminPanel from "./pages/AdminPanel";
import Storefront from "./pages/Storefront";
import ProductPage from "./pages/ProductPage";
import CategoryBrowse from "./pages/CategoryBrowse";
import EventsBrowse from "./pages/EventsBrowse";
import CityPage from "./pages/CityPage";
import CityRedirect from "./pages/CityRedirect";
import VenuePage from "./pages/VenuePage";
import ActPage from "./pages/ActPage";
import FanFeed from "./pages/FanFeed";
import NotFound from "./pages/NotFound";
import VenueDashboard from "./pages/VenueDashboard";
import VoucherPage from "./pages/VoucherPage";
import PassPage from "./pages/PassPage";
import VoucherConfirm from "./pages/VoucherConfirm";
import CheckBalance from "./pages/CheckBalance";
import EmbedEventCard from "./pages/EmbedEventCard";
import EmbedEvents from "./pages/EmbedEvents";
import ArtistSignup from "./pages/ArtistSignup";
import ArtistClaim from "./pages/ArtistClaim";
import ArtistDashboard from "./pages/ArtistDashboard";
import ArtistPublic from "./pages/ArtistPublic";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SiteMeta />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/venue-forgot" element={<VenueForgotPassword />} />
            <Route path="/venue-reset" element={<VenueResetPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/venue" element={<VenueDashboard />} />
            <Route path="/door" element={<StaffDoor />} />
            <Route path="/events" element={<EventsBrowse />} />
            <Route path="/events/category/:category" element={<CategoryBrowse />} />
            <Route path="/events/city/:city" element={<CityRedirect />} />
            <Route path="/city/:slug" element={<CityPage />} />
            <Route path="/venues/:citySlug/:venueSlug" element={<VenuePage />} />
            <Route path="/acts/:actSlug" element={<ActPage />} />
            <Route path="/following" element={<FanFeed />} />
            <Route path="/store/:slug" element={<Storefront />} />
            <Route path="/store/:slug/acts/:actSlug" element={<ActPage />} />
            <Route path="/store/:slug/events/:productSlug" element={<ProductPage />} />
            <Route path="/store/:slug/vouchers/:productSlug" element={<ProductPage />} />
            <Route path="/voucher/confirm" element={<VoucherConfirm />} />
            <Route path="/voucher/:code" element={<VoucherPage />} />
            <Route path="/pass/:code" element={<PassPage />} />
            <Route path="/ticket/:code" element={<VoucherPage />} />
            <Route path="/check-balance" element={<CheckBalance />} />
            <Route path="/embed/store/:slug/events/:productSlug" element={<EmbedEventCard />} />
            <Route path="/embed/store/:slug" element={<EmbedEvents />} />
            <Route path="/artist-signup" element={<ArtistSignup />} />
            <Route path="/artist/claim/:token" element={<ArtistClaim />} />
            <Route path="/artist" element={<ArtistDashboard />} />
            <Route path="/artists/:slug" element={<ArtistPublic />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
